import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { sensors } from '@/utils/sensors'
import { getCurrentInstance, watch } from 'vue'
import {  useRoute } from "vue-router";
import { useStore } from "vuex";
import { useI18n } from 'vue-i18n'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route: any = useRoute();
const { locale } = useI18n()
sensors()
const store = useStore();
// store.dispatch('setMessageCount') // 目前该项目只用于售后(后期可能会用于邀请备货),故不需要请求以前k系统的聊天数据
const internalInstance  = getCurrentInstance()
internalInstance?.appContext.config.globalProperties.$sa.quick('autoTrack',{
    platform_type:"Wap",
    client_name: 'NewWap'
}) 
const view_update_sa_pageview_fn = (): void => {
    internalInstance?.appContext.config.globalProperties.$sa.quick('autoTrackSinglePage', {
      platform_type:"Wap", 
      client_name: 'NewWap'
    })
}

watch(() => route.path,() => {  
    view_update_sa_pageview_fn(); // 路由更改掉用神策记录浏览事件 $pageview
})
watch(() => store.getters.language,() => {  
  locale.value = store.getters.language || 'en'
})
window.addEventListener('message', e => {
  // const originText = process.env.NODE_ENV === "production" ? 'https://seller.kilimall.ke' : 'https://seller-gw.kilitest.com/'
  const urlArr = ['https://seller.kilimall.ke', 'https://seller-gw.kilitest.com']
  if( e.data.key === 'lang' && urlArr.includes(e.origin)) {
    locale.value = e.data.value
    store.dispatch('setLanguages',locale.value) 
  }
})

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})